import User from './User'
import Menu from './Menu'
import UserTypeGroup from './UserTypeGroup'
import Privacy from './Privacy'
import PrivacyCheck from './PrivacyCheck'
import Running from './Running'
import Token from './Token'
import FileUpload from './FileUpload'
import Shop from './Shop'
import ListShop from './ListShop'
import EditShop from './EditShop'
import ListMember from './ListMember'
import VgroupMapCoin from './VgroupMapCoin'
import ManageShop from './ManageShop'
import ListAllShop from './ListAllShop'
import Errorpage from './Errorpage'
import GivePoints from './GivePoints'
import ManageApi from './ManageApi'
import Transport from './Transport'
import Friendgetfriend from './Friendgetfriend'
import pointFree from './pointFree'

export default {
  User,
  Menu,
  UserTypeGroup,
  Privacy,
  PrivacyCheck,
  Running,
  Token,
  FileUpload,
  Shop,
  ListShop,
  ListMember,
  EditShop,
  VgroupMapCoin,
  ManageShop,
  ListAllShop,
  Errorpage,
  GivePoints,
  ManageApi,
  Transport,
  Friendgetfriend,
  pointFree
}



// WEBPACK FOOTER //
// ./src/components/System/index.js